// @flow

import _ from 'lodash/fp';
import React from 'react';
import classNames from 'classnames';
import './CustomerProductImage.css';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

export type Props = {
  file?: any,
  className?: string,
  size?: ?string,
  onClick?: ?Function,
  showOverlay?: boolean,
};

const CustomerProductImage = ({
  file,
  className,
  size,
  onClick,
  showOverlay = false,
}: Props) => (
  <div
    className={classNames({
      CustomerProductImage: true,
      clickable: !!onClick,
      ...(!!className
        ? _.flow(
          _.split(' '),
          _.reduce((a, b) => {
            a[b] = true;
            return a;
          }, {}),
        )(className)
        : {}
      ),
    })}
    onClick={() => {
      if (!!onClick) {
        onClick();
      }
    }}>
    {!file &&
      <div className="no-image">
        <i className="fa fa-file-image-o" />
      </div>
    }
    {file && !showOverlay &&
      <img
        src={`${fileUrl}/preview/${file.id}/${size || 600}`}
        alt="" />
    }
    {file && showOverlay &&
      <div className="center-wrapper">
        <img
          src={`${fileUrl}/preview/${file.id}/${size || 600}`}
          alt="" />
        <div className="CustomerProductImage-popup-info">
          Tryck för att zooma
        </div>
        <span className="CustomerProductImage-popup-info-icon">
          <i className="fa fa-search-plus" />
        </span>
      </div>
    }
  </div>
);

export default CustomerProductImage;



// WEBPACK FOOTER //
// ./src/components/CustomerProductImage/CustomerProductImage.js